export const flightSelectionAction={
    UPDATEFLIGHTINDEX:"UPDATEFLIGHTINDEX",
    SAVEFLIGHTSELECTIONSUMMARY:"SAVEFLIGHTSELECTIONSUMMARY",
    SAVESELECTEDITINERARYPARTS:"SAVESELECTEDITINERARYPARTS",
    SAVESELECTEDRESULT:"SAVESELECTEDRESULT",
    UPDATESEARCHRESPONSE : "UPDATESEARCHRESPONSE"
}